import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");

    try {
      const res = await fetch(
        "https://nazarenterprise.com/nazar-admin/send-mail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await res.json();

      if (data.success) {
        setResponseMsg("Thank you! Your message has been sent successfully.");
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      } else {
        setResponseMsg(
          data.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      setResponseMsg(
        "Network error. Please check your connection and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="contact-page">
        <div className="container">
          <div className="row">
            {/* Left Side - Contact Info */}
            <div className="col-xl-4 col-lg-4 col-md-5">
              <div className="contact-page__content">
                <div className="title">
                  <h2>Get In Touch</h2>
                </div>

                {/* Address */}
                <div className="contact-page__content-single">
                  <div className="contact-page__content-single-inner">
                    <div className="icon-box">
                      <span className="icon-pin"></span>
                    </div>
                    <div className="content-box">
                      <h2>Address</h2>
                      <p>Diwanpara Road, Bhavnagar, Gujarat</p>
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div className="contact-page__content-single">
                  <div className="contact-page__content-single-inner">
                    <div className="icon-box">
                      <span className="icon-phone-call-1"></span>
                    </div>
                    <div className="content-box">
                      <h2>Phone</h2>
                      <p className="number1">
                        <a href="tel:+919409072990">+91 94090 72990</a>
                      </p>
                      <p className="number2">
                        <a href="tel:+918140702552">+91 81407 02552</a>
                      </p>
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="contact-page__content-single">
                  <div className="contact-page__content-single-inner">
                    <div className="icon-box">
                      <span className="icon-email"></span>
                    </div>
                    <div className="content-box">
                      <h2>Email</h2>
                      <p className="email1">
                        <a href="mailto:sales@nazarenterprise.com">
                          sales@nazarenterprise.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="col-xl-8 col-lg-8 col-md-7">
              <div className="contact-page__form">
                <form
                  onSubmit={handleSubmit}
                  className="comment-one__form contact-form-validated"
                >
                  <div className="row">
                    <div className="col-xl-6 col-lg-6">
                      <div className="comment-form__input-box">
                        <input
                          type="text"
                          placeholder="Full name *"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                      <div className="comment-form__input-box">
                        <input
                          type="email"
                          placeholder="Email address *"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-6 col-lg-6">
                      <div className="comment-form__input-box">
                        <input
                          type="text"
                          placeholder="Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                      <div className="comment-form__input-box">
                        <input
                          type="text"
                          placeholder="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12 col-lg-12">
                      <div className="comment-form__input-box text-message-box">
                        <textarea
                          name="message"
                          placeholder="Your Message *"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>

                      <button
                        className="thm-btn comment-form__btn"
                        type="submit"
                        disabled={loading}
                        data-text={loading ? "Sending..." : "Send Message +"}
                      >
                        <span>{loading ? "Sending..." : "Send Message +"}</span>
                      </button>

                      {/* Success / Error Message */}
                      {responseMsg && (
                        <div
                          className="mt-3"
                          style={{
                            padding: "15px",
                            borderRadius: "5px",
                            backgroundColor: responseMsg.includes("Thank you")
                              ? "#d4edda"
                              : "#f8d7da",
                            color: responseMsg.includes("Thank you")
                              ? "#155724"
                              : "#721c24",
                            border: `1px solid ${
                              responseMsg.includes("Thank you")
                                ? "#c3e6cb"
                                : "#f5c6cb"
                            }`,
                          }}
                        >
                          {responseMsg}
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
